import api from '@/services/api'
import emailCheck from 'script/emailCheck.js'
import bugsnag from 'services/bugsnag'

const manditoryFields = ['email', 'firstName', 'lastName', 'address', 'city', 'postCode', 'phoneNumber']

export default {
  state: {
    headQPrice: 2975,
    headQDiscountedPrice: 0,
    isPendingCouponCode: false,
    invalidCouponCode: false,
    shippingPrice: 0,
    quantity: 1,
    abTestCode: null,
    couponCode: '',
    partnerCode: '',
    email: '',
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    postCode: '',
    phoneNumber: '',
    paymentOption: 'invoice',
    showKlarnaPaymentOption: true
  },
  mutations: {
    headQPrice: (state, value) => { state.headQPrice = value },
    headQDiscountedPrice: (state, value) => { state.headQDiscountedPrice = value },
    isPendingCouponCode: (state, value) => { state.isPendingCouponCode = value },
    invalidCouponCode: (state, value) => { state.invalidCouponCode = value },
    shippingPrice: (state, value) => { state.shippingPrice = value },
    quantity: (state, value) => { state.quantity = Number(value) },
    abTestCode: (state, value) => { state.abTestCode = value },
    couponCode: (state, value) => { state.couponCode = value },
    partnerCode: (state, value) => { state.partnerCode = value },
    email: (state, value) => { state.email = value },
    firstName: (state, value) => { state.firstName = value },
    lastName: (state, value) => { state.lastName = value },
    address: (state, value) => { state.address = value },
    city: (state, value) => { state.city = value },
    postCode: (state, value) => { state.postCode = value },
    phoneNumber: (state, value) => { state.phoneNumber = value },
    paymentOption: (state, value) => { state.paymentOption = value },
    showKlarnaPaymentOption: (state, value) => { state.showKlarnaPaymentOption = value }
  },
  getters: {
    headQPrice: state => state.headQPrice,
    headQDiscountedPrice: state => state.headQDiscountedPrice,
    isPendingCouponCode: state => state.isPendingCouponCode,
    invalidCouponCode: state => state.invalidCouponCode,
    shippingPrice: state => state.shippingPrice,
    quantity: state => state.quantity,
    abTestCode: state => state.abTestCode,
    couponCode: state => state.couponCode,
    partnerCode: state => state.partnerCode,
    email: state => state.email,
    firstName: state => state.firstName,
    lastName: state => state.lastName,
    address: state => state.address,
    city: state => state.city,
    postCode: state => state.postCode,
    phoneNumber: state => state.phoneNumber,
    paymentOption: state => state.paymentOption,
    showKlarnaPaymentOption: state => state.showKlarnaPaymentOption,
    validEmail: state => emailCheck(state.email),
    validPaymentInformation: (_state, getters) => {
      if (!getters.validEmail) {
        return false
      }

      // Check if any field is empty
      let isValid = true
      manditoryFields.forEach(attr => {
        if (getters[attr] === '') {
          isValid = false
        }
      })

      return isValid
    },
    customerInformation: state => {
      const info = {}

      manditoryFields.forEach(attr => {
        info[attr] = state[attr]
      })

      return info
    },
    headQFinalPrice: state => {
      if (state.headQDiscountedPrice > 0) {
        return state.headQDiscountedPrice
      }

      return state.headQPrice
    },
    totalDiscountAmount: state => {
      if (state.headQDiscountedPrice === 0) {
        return 0
      }

      const discount = state.headQPrice - state.headQDiscountedPrice
      return state.quantity * discount
    },
    totalAmount: (state, getters) => {
      return state.quantity * getters.headQFinalPrice
    },
    totalTaxAmount: (_state, getters) => {
      return getters.totalAmount * (1 - 1 / 1.25)
    },
    klarnaOrderLines: (state, getters) => {
      // DOCS: https://developers.klarna.com/api/#checkout-api-callbacks-address-update
      const totalAmount = getters.totalAmount
      const orderLines = [{
        type: 'physical',
        reference: '1',
        name: 'HeadQ',
        quantity: state.quantity,
        unit_price: 100 * state.headQPrice, // in öre
        tax_rate: 2500, // 25% -> 2500
        total_amount: 100 * totalAmount,
        total_discount_amount: 100 * getters.totalDiscountAmount,
        total_tax_amount: Math.round(100 * getters.totalTaxAmount),
        product_url: 'https://www.rideq.se/order'
      }]

      return orderLines
    }
  },
  actions: {
    async checkCouponCode ({ commit, getters }) {
      let couponCode = getters.couponCode
      if (couponCode === '' || getters.isPendingCouponCode) {
        return
      }

      if (couponCode.indexOf(' ') !== -1) {
        couponCode = couponCode.replace(/ /g, '')
      }

      commit('isPendingCouponCode', true)
      commit('invalidCouponCode', false)

      try {
        const res = await api.getCouponPrice(couponCode)
        let price = res.data.price
        if (typeof price !== 'number') {
          commit('isPendingCouponCode', false)
          return Promise.reject(new Error('Invalid price'))
        }

        commit('headQDiscountedPrice', price)
      } catch (err) {
        commit('headQDiscountedPrice', 0)
        commit('invalidCouponCode', true)

        bugsnag.notify(err, { couponCode })
      }

      commit('isPendingCouponCode', false)
    }
  }
}
